module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoiceRecord"
  }, [_c('pull-to', {
    attrs: {
      "top-load-method": _vm.topRefreshFn,
      "bottom-load-method": _vm.bottomRefreshFn
    }
  }, _vm._l((_vm.content), function(item, index) {
    return _c('xk-invoice-record-mod', {
      key: index,
      attrs: {
        "time": '2017.01 08:20',
        "sum": '529.00',
        "memo": '专车',
        "type": '纸质发票',
        "state": 1
      }
    })
  }), 1), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-088fb4b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mewallet/invoice/invoiceRecord.vue
// module id = 503
// module chunks = 0